import { create } from 'zustand'
import { GraphNodeData } from '@/types/graph'

interface InspectStore {
  selectedNodeId: string | null
  selectedNode: GraphNodeData | null
  disclosureLevel: 'essential' | 'advanced' | 'expert'
  setSelectedNodeId: (id: string | null) => void
  setSelectedNode: (node: GraphNodeData | null) => void
  setDisclosureLevel: (level: 'essential' | 'advanced' | 'expert') => void
  clear: () => void
}

export const useInspectStore = create<InspectStore>((set) => ({
  selectedNodeId: null,
  selectedNode: null,
  disclosureLevel: 'essential',
  setSelectedNodeId: (id) => set({ selectedNodeId: id }),
  setSelectedNode: (node) => set({ selectedNode: node }),
  setDisclosureLevel: (level) => set({ disclosureLevel: level }),
  clear: () =>
    set({
      selectedNodeId: null,
      selectedNode: null,
      disclosureLevel: 'essential',
    }),
}))
